module.exports = __webpack_public_path__ + "assets/img/WeChaticon.30dbb456.png";